import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';


@Injectable({
    providedIn: 'root'
})
export class VoiceService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }

    //TM Side
    public getentityname(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.GETENTITYNAME, data);
    }

    public newVoiceHeaderRegTM(data): Observable<any> {
        console.log("data   ", data);
        const headers = new HttpHeaders();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'multipart/form-data');
        headers.set('Access-Control-Allow-Origin', "*");
        return this.http.post(APIConstants.POSTVOICENEWHEADERREGTM, data, { headers });

    }
    public voiceheaderFilter(data): Observable<any> {
        return this.http.post(APIConstants.VOICEHEADERFILTERDET, data);
    }
    public getVoiceHeaderDetailsbyURN(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.GETVOICEHEADERDETAILSBYURN, data);
    }
    public VoiceHeaderModTM(data): Observable<any> {
        console.log("data   ", data);
        const headers = new HttpHeaders();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'multipart/form-data');
        headers.set('Access-Control-Allow-Origin', "*");
        return this.http.post(APIConstants.POSTVOICENEWHEADERMODTM, data, { headers });
    }
    public exportTmListCSV(data): Observable<any> {
        console.log("data   ", data);
        return this.http.post(APIConstants.EXPORTTMLISTCSV, data, { responseType: "blob" });
    }

    //PE Side
    public getVoiceHeaderRegPE(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.GETVOICEHEADERREGPE, data);
    }
    public newVoiceHeaderRegPE(data): Observable<any> {
        console.log("data   ", data);
        const headers = new HttpHeaders();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'multipart/form-data');
        //  headers.set('Access-Control-Allow-Origin',"*");
        headers.set('AllowAllOrigins', "*");
        return this.http.post(APIConstants.POSTVOICENEWHEADERREGPE, data, { headers });
    } 
    public voiceheaderpeFilter(data): Observable<any> {
        return this.http.post(APIConstants.VOICEHEADERPEFILTERDET, data);
    }
    public downloadFilenow(file1): Observable<any> {

        return this.http.post(APIConstants.FILEDOWNLOADNOW, file1, { responseType: "blob" });
    }
    public fetchvoicehdrforPE(data): Observable<any> {
        return this.http.post(APIConstants.FETCHVOICEHDRFORPE, data);
    }
    public voicesuspensionreactivation(data): Observable<any> {
        return this.http.post(APIConstants.GETVOICESUSPENSION, data);
    }
    public exportPeListCSV(data): Observable<any> {
        console.log("data   ", data);
        return this.http.post(APIConstants.EXPORTPELISTCSV, data, { responseType: "blob" });
    }


    public voicetemplateregistration(data): Observable<any> {
        return this.http.post(APIConstants.VOICETEMPLATEREGISTRATION, data);
    }    
    public voicetemplatemodification(data): Observable<any> {
        return this.http.post(APIConstants.VOICETEMPLATEMODIFICATION, data);
    }
    public updateVoiceTemplate(data): Observable<any> {
        return this.http.post(APIConstants.UPDATEVOICETEMPLATE, data);
    }
    public getVoiceContentEntityDetailsbyPE(data): Observable<any> {
        return this.http.post(APIConstants.GETVOICECONTENTENTITYDETAILSBYPE, data);
    }
    public getVoicepeTemplateSummaryMongo(status): Observable<any> {    
        return this.http.post(APIConstants.GETVOICEPETEMPLATESUMMARYMONGO, status); 
    }   
    public VoiceTemplatepeFilter(status): Observable<any> {
        return this.http.post(APIConstants.VOICETEMPLATEPEFILTER, status);
    }
    public downloadvoiceTemplatesbyPE(Status): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADVOICETEMPLATEBYPE, Status, { responseType: "blob" });
    }
    public GetActionbype(data): Observable<any> {
        return this.http.post(APIConstants.GETACTIONBYPE, data);
    }    
    public getVoiceTemplateDetails(data): Observable<any> {
        return this.http.post(APIConstants.GETVOICETEMPLATEDETAILS, data);
    }
    public voiceTempfiledownload(file: any): Observable<any> {
        return this.http.post(APIConstants.GETVOICETEMPLATEFILEDOWNLOAD, file, { responseType: "blob" });
    }
    public VoiceEntityModification(status): Observable<any> {
        return this.http.post(APIConstants.VOICEENTITYMODIFICATION, status);
    }
    
    //Registrar
    public voiceheaderregFilter(data): Observable<any> {
        return this.http.post(APIConstants.GETVOICEHEADERREGDET, data);
    }
    public getVoiceHeaderRegbyurn(data): Observable<any> {
        return this.http.post(APIConstants.GETVOICEHEADERREGBYURN, data);
    }
    public getVoiceHdrAuditLogsByUrn(data): Observable<any> {
        return this.http.post(APIConstants.GETVOICEHDRAUDITLOGSBYURN, data);
    }
    public newVoiceHeaderApprovalTSP(data): Observable<any> {
        const headers = new HttpHeaders();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'multipart/form-data');
        headers.set('Access-Control-Allow-Origin', "*");
        return this.http.post(APIConstants.POSTVOICEHEADERAPPROVALBYTSP, data, { headers });
    }
    public getVoiceHeaderWorkListFilter(data: any): Observable<any> {
        return this.http.post(APIConstants.GETVOICEHEADERWORKLISTFILTER, data);
    }
    public voiceHeaderReports(data): Observable<any> {
        return this.http.post(APIConstants.GETVOICEHEADERREPORTS, data);
    }
    public downloadblobFile(file1): Observable<any> {
        return this.http.post(APIConstants.FILEDOWNLOADBLOB, file1, { responseType: "blob" });
    }    
    public exportVoiceExcelWL(data): Observable<any> {
        return this.http.post(APIConstants.EXPORTCSVVOICEHEADERWL, data, { responseType: "blob" });
    }
    public exportvoicehdrAuditLogsworklist(data): Observable<any> {    
        return this.http.post(APIConstants.EXPORTCSVVOICEHEADERAUDITLOGS, data, { responseType: "blob" });
    }
    public GetActionbyTSP(data): Observable<any> {
        return this.http.post(APIConstants.GETACTIONBYTSP, data);
    }
    public EntityDetailsforvoice(data: any): Observable<any> {
        return this.http.post(APIConstants.ENTITYDETAILSFORVOICE, data);
    }
    public Bulksuspensionbytsp(data): Observable<any> {
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.BULKSUSPENSIONBYTSP, data, { headers });
    }
    public bulkVoicehdrSuspensionSummary(data): Observable<any> {
        return this.http.post(APIConstants.BULKVOICEHDRSUSPENSIONSUMMARY, data);
    }
    public downloadVoicehdrSummary(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADVOICEHDRSUMMARY, data, { responseType: "blob" });
    }

    public voiceTempEntityDetails(file: any): Observable<any> {
        return this.http.post(APIConstants.GETVOICECONTENTENTITYDETAILS, file, { responseType: "blob" });
    }
    public getVoiceTemplateSummaryMongo(status): Observable<any> {
        console.log(" status for checking in service ---  ", status)
        return this.http.post(APIConstants.GETVOICETEMPLATESUMMARYMONGO, status);
    }
    public voiceTempRegistration(file: any): Observable<any> {
        return this.http.post(APIConstants.VOICETEMPLATEREG, file, { responseType: "blob" });
    }
    public VoiceTemplateTSPFilter(data): Observable<any> {
        return this.http.post(APIConstants.VOICETEMPLATETSPFILTER, data);
    }    
    public downloadVoicetemplatecsvfile(Status): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADVOICETEMPLATEWORKLISTDETAILS, Status, { responseType: "blob" });
    }
    public TemplateSuspensionReactivationbyTSP(data): Observable<any> {
        return this.http.post(APIConstants.TEMPLATESUSPENSIONREACTIVATIONBYTSP, data);
    }

    //VOICE SERVICE HEADER
    //PE Side

    public gettmnamedet(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.GETTMDET, data);
    }

    public newVoiceServiceHeaderRegPe(data): Observable<any> {     
        const headers = new HttpHeaders();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'multipart/form-data');
        headers.set('Access-Control-Allow-Origin', "*");
        return this.http.post(APIConstants.POSTVOICESERVICENEWHEADERREGPE, data, { headers });
    }
    
    public VoiceHeaderModPE(data): Observable<any> {
        console.log("data   ", data);
        const headers = new HttpHeaders();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'multipart/form-data');
        headers.set('Access-Control-Allow-Origin', "*");
        return this.http.post(APIConstants.POSTVOICESERVICEHEADERMODPE, data, { headers });
    }
    
    public voiceServiceHeaderbypeFilter(data): Observable<any> {
        return this.http.post(APIConstants.VOICESERVICEHEADERFILTERDET, data);
    }

    public voiceServiceSuspensionReactivation(data): Observable<any> {
        return this.http.post(APIConstants.VOICESERVICESUSPENSION, data);
    }
    
    public exportServiceHeaderpeListCSV(data): Observable<any> {       
        return this.http.post(APIConstants.EXPORTSERVICEHEADERPELISTCSV, data, { responseType: "blob" });
    }
   
    public voiceserviceheadertmFilter(data): Observable<any> {
        return this.http.post(APIConstants.VOICESERVICEHEADERTMWL, data);
    }

    public getVoiceServiceHeaderRegTM(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.GETVOICESERVICEHEADERTM, data);
    }

    public newVoiceServiceHeaderRegTM(data): Observable<any> {
        console.log("data   ", data);
        const headers = new HttpHeaders();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'multipart/form-data');
        //  headers.set('Access-Control-Allow-Origin',"*");
        headers.set('AllowAllOrigins', "*");
        return this.http.post(APIConstants.POSTVOICESERVICEHEADERTM, data, { headers });
    }   

    public exportTMListCSV(data): Observable<any> {
        console.log("data   ", data);
        return this.http.post(APIConstants.EXPORTSERVICEHEADERTMLISTCSV, data, { responseType: "blob" });
    }

    public getVoiceServiceHeaderByUrn(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.GETVOICESERVICEHEADERBYURN, data);
    }

    public downloadVoiceServiceFile(file1): Observable<any> {

        return this.http.post(APIConstants.VOICESERVICEFILEDOWNLOAD, file1, { responseType: "blob" });
    }
}